/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanDocumentResponse { 
    id?: number;
    documentId?: string;
    documentTypeId?: number;
    creationTime?: string;
    userId?: number;
    tenantId?: number;
    documentFileName?: string | null;
    isDeleted?: boolean;
    loanDocumentType?: string | null;
    fileType?: string | null;
}

